import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ManageControllersList } from '../../components/Sensors/ManageControllersList';
import CustomSnackbar from '../../components/CustomSnackbar';
import MDBox from 'components/MDBox';
import DashboardNavbar from '../../examples/Navbars/DashboardNavbar';
import DashboardLayout from '../LayoutContainers/DashboardLayout';

export const ManageControllers = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  useEffect(() => {
    const nextNotification = location.state?.notification;
    if (!nextNotification) return;
    setNotification({ ...nextNotification, open: true });
    navigate(location.pathname, { replace: true, state: {} });
  }, [location.pathname, location.state, navigate]);

  return (
    <DashboardLayout>
      <DashboardNavbar objectName="manage controllers" />
      <Typography
        fontSize="11px"
        sx={{
          paddingLeft: { xs: 0, sm: '12px' },
          marginTop: { xs: '-15px', sm: '-5px' },
          textAlign: { xs: 'center', sm: 'left' },
        }}>
        Smart indoor air monitoring & management platform
      </Typography>
      <MDBox>
        <Grid container>
          <Grid item xs={12}>
            <ManageControllersList />
          </Grid>
        </Grid>
      </MDBox>
      <CustomSnackbar
        open={notification.open}
        onClose={() => setNotification(prev => ({ ...prev, open: false }))}
        duration={4000}
        severity={notification.severity}
        message={notification.message}
        vertical="bottom"
        horizontal="center"
        color="#fff"
      />
    </DashboardLayout>
  );
};

export default ManageControllers;
